import { render, staticRenderFns } from "./NotificationFundraisingFinished.vue?vue&type=template&id=0cd3841b&scoped=true&"
import script from "./NotificationFundraisingFinished.vue?vue&type=script&lang=ts&"
export * from "./NotificationFundraisingFinished.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationFundraisingFinished.vue?vue&type=style&index=0&id=0cd3841b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd3841b",
  null
  
)

export default component.exports